import { useContext, useEffect, CSSProperties, useState } from "react"
import { DataContext } from "../data/DataContext"
import { lstTypeDocument } from "../data/MochaData"
import {
  DropDown,
  Input,
  DateControl,
  CheckBox
} from "../components"

import { CalculateAge } from '../../../utils/helpMain'
import Modal from 'react-modal'


const StepPersonalData = () => {
  const { vidaCR, setVidaCR, changeHandler, changeHandler2 } = useContext(DataContext);
  const [openModal, setOpenModal] = useState(false);


  const onChange = (property: string, value: string) => setVidaCR({ ...vidaCR, [property]: value })
  const onChangeDate = (property: string, value: any) => {
    const ageCal = CalculateAge(value);
    setVidaCR({ ...vidaCR, [property]: value, age: ageCal, lstRateResumen: [], nQuotas: '', planSelected: '' })
  }

  const onChangeChk = (property: string, value: any) => {
    if (value)
      setOpenModal(true)
    setVidaCR({ ...vidaCR, [property]: value })
  }



  const styleModal = {

    content: {
      border: "1px solid #E1E1E1",
      borderRadius: '2%',

    }, overlay: {
      backgroundColor: "rgba(255, 255, 255, 0.5)",

    }

  } as Modal.Styles

  return (
    <>
      <DropDown
        label="Tipo de identificación"
        field="typeDocument"
        valueSelect={vidaCR.typeDocument}
        dataProvider={lstTypeDocument}
        onChangeSelect={onChange}
      />
      {vidaCR.typeDocument === '1' &&
        <Input
          id="identification"
          label="Número de identificación"
          value={vidaCR.identification}
          field="identification"
          onChange={changeHandler}
          type="mask"
          mask="9-9999-9999"
          pattern="\d-\d\d\d\d-\d\d\d\d"
          title="Documento invalido"
        />
      }
      {vidaCR.typeDocument !== '1' &&
        < Input
          id='identification'
          label='Número de identificación'
          value={vidaCR.identification}
          field='identification'
          onChange={changeHandler}
        />
      }
      <Input
        id="name1"
        field="name1"
        label="Nombres"
        onChange={changeHandler}
        value={vidaCR.name1}
      />
      <Input
        id="name2"
        field="name2"
        label=""
        onChange={changeHandler}
        value={vidaCR.name2}
        onlyInput
        isRequired={false}
      />
      <Input
        id="lastname1"
        field="lastname1"
        label="Apellidos"
        onChange={changeHandler}
        value={vidaCR.lastname1}
      />
      <Input
        id="lastname2"
        field="lastname2"
        label="Nombres"
        onChange={changeHandler}
        value={vidaCR.lastname2}
        onlyInput
        isRequired={false}
      />
      <DateControl
        id="birthdate"
        label="Fecha de nacimiento"
        onChange={onChangeDate}
        value={vidaCR.birthdate}
        maxDate={new Date()}

      />
      <Input
        id="age"
        field="age"
        label="Edad"
        onChange={changeHandler}
        value={vidaCR.age}
        isReadOnly
        isRequired
      />
      <DropDown
        label="Provincia"
        field="province"
        valueSelect={vidaCR.province}
        dataProvider={vidaCR.catProvince}
        onChangeSelect={onChange}
      />
      <DropDown
        label="Cantón"
        field="canton"
        valueSelect={vidaCR.canton}
        dataProvider={vidaCR.catCanton}
        onChangeSelect={onChange}
      />
      <DropDown
        label="Distrito"
        field="district"
        valueSelect={vidaCR.district}
        dataProvider={vidaCR.catDistrict}
        onChangeSelect={onChange}
      />
      <DropDown
        label="Barrio"
        field="neighborhood"
        valueSelect={vidaCR.neighborhood}
        dataProvider={vidaCR.catNeighborhood}
        onChangeSelect={onChange}
      />
      <Input
        id='address'
        label='Dirección'
        field='address'
        value={vidaCR.address}
        onChange={changeHandler}
        type='textarea'
      />
      <Input
        id='cellPhoneNumber'
        label='Número de Celular'
        field='cellPhoneNumber'
        value={vidaCR.cellPhoneNumber}
        onChange={changeHandler}
        placeholder='0000-0000'
        type='mask'
        mask="9999-9999"
        title="Documento invalido"
      />
      <Input
        label='Correo electrónico'
        value={vidaCR.email}
        onChange={changeHandler}
        field='email'
        id='email'
      />
      <CheckBox
        field="acceptTerms"
        label="Acepto que he leído y consecuentemente brindo mi consentimiento a SEGUROS LAFISE para el uso de mi información según lo indicado en las Políticas de Privacidad, Términos y Condiciones."
        value={vidaCR.acceptTerms ?? false}
        onChange={onChangeChk}
        onClickLabel={() => setOpenModal(true)}
      />
      <Modal className="modal" isOpen={openModal} style={styleModal} preventScroll={false} shouldCloseOnEsc={false} shouldCloseOnOverlayClick={false} >

        <div className="modal-body-info" style={{ textAlign: 'justify' }}>
          <p className="lbl-input-vida-cr  mt-20 mb-20" style={{ textAlign: 'justify', width: '80%', marginLeft: '10%', lineHeight: '20px' }}>
            En cumplimiento con la Ley 8204 y la Política Conozca a su Cliente,
            declaro que este formulario ha sido completado por mí y/o en mi presencia
            y que la información provista en el mismo es fiel y verdadera.
            Asi mismo, declaro que los recursos por movilizar a través de Seguro LAFISE (en adelante S.L.)
            provienen de actividades lícitas. La información de este formulario
            puede ser utilizada por cualquiera de las empresas del S.L. para los fines respectivos.
          </p>
        </div>

        <div className="modal-footer">
          {<button className="modal-btn-close" style={{ background: '#008866' }} onClick={(e) => { e.preventDefault(); setOpenModal(false) }}>Cerrar</button>}
        </div>
      </Modal>


    </>
  )
}

export { StepPersonalData };